import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'amfe-flexible';
import * as services from './service';
import CheUI from './assets/js/che-ui';
import './libs/vant'

import './assets/js/fulltilt.js';
import VueLazyload from "vue-lazyload";
import * as Sentry from "@sentry/vue";
import { setTitle } from './utils/index'
// 版本检查
try {
	const packageVersion = require('../package.json').version;
	fetch(`./version.json?t=${new Date().getTime()}`).then(res => res.json()).then(({version}) => {
		console.log('[version] 从服务器文件读取到的version: ', version);
		console.log('[version] : ', packageVersion);
		if (process.env.VUE_APP_ENV === 'ser正在使用versionve') {
			console.log('[version] 哦，是本地服务呀');
		} else if (String(version) !== String(packageVersion)) {
			console.log('[version] 版本不一致，需要刷新');
			window.location.reload();
		} else {
			console.log('[version] 与服务器部署的版本一致');
		}
	}).catch(res => {
		console.log('[version] 读取version.json失败', res);
	});
} catch (e) {
	console.log('[version] 版本检查出错', e);
}

if (process.env.VUE_APP_ENV === 'serve') {
	Vue.config.devtools = true
}
Vue.config.productionTip = false;

Vue.use(CheUI);
Vue.use(VueLazyload, {
	loading: require('./assets/img/loading.gif'),
	attempt: 3
});

// try {
// 	let [source] = location.href.match(/source=[^&]*/) || [];
// 	if (source) {
// 		source = source.replace('source=', '');
// 	}
// 	console.log('source:', source);
// 	if (source === 'mp') {
// 		document.title = '城际大巴车';
// 	} else {
// 		document.title = '网约巴士';
// 	}
// } catch (e) {
// 	console.log(e);
// }

setTitle()

Sentry.init({
  Vue,
  dsn: "https://e54f876a5ab3d8615185046b27eab910@maas.chelaile.net.cn/chelaile-sentry/15",
	enabled: process.env.VUE_APP_ENV === 'production'
});

const vm = new Vue({
  router,
  store,
  render: h => h(App)
});

Object.values(services).forEach(service => {
	service.install(Vue, vm);
});

vm.$mount('#app');
